module.exports = __webpack_public_path__ + "img/process-1.1560fda6.png";